var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-modal", {
    attrs: {
      title: _vm.$t("修改密码"),
      maskClosable: false,
      "cancel-button-props": {
        style: {
          display: "none"
        }
      },
      okText: _vm.visibleVerifyTab ? _vm.$t("下一步") : _vm.$t("确定")
    },
    on: {
      ok: _vm.confirmEditModal,
      cancel: _vm.cancleEditModal
    },
    model: {
      value: _vm.visibleEditModal,
      callback: function ($$v) {
        _vm.visibleEditModal = $$v;
      },
      expression: "visibleEditModal"
    }
  }, [_vm.visibleVerifyTab ? _c("div", {
    staticClass: "tips"
  }, [_vm._v(" *" + _vm._s(_vm.$t("为了保护您的账号安全，需要验证您的身份，验证能够通过后即可修改密码。")) + " ")]) : _vm._e(), _vm.visibleVerifyTab ? _c("verifyTab", {
    key: "verifyTab",
    ref: "verifyRef",
    attrs: {
      way: "updatePassword",
      visibleEditModal: _vm.visibleEditModal
    }
  }) : _vm._e(), _vm.visibleEditPwd ? _c("editPassword", {
    key: "editPassword",
    ref: "editPwdRef"
  }) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };